import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import PickImage from "@/components/view/PickImage.vue";
import {orderStatusColumns, orderTypeColumns} from "@/components/model/data";
import {formatDateTime} from "@/components/ts/components";
import {nextTick, reactive, watch} from "vue";
import {getFaceImage, mobileOrders} from "@/api/order";
import {message} from "ant-design-vue";
import {getClinicInfo, getUsedRechargeFrequencyWithUserId} from "@/api/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'monitorUseSituation',
  props: {
    relatedId: {
        type: String,
        default: ""
    },
    clinicId: {
        type: String,
        default: ""
    },
},
  setup(__props) {

const prop = __props;




watch(
    () => prop.clinicId, async () => {
        await nextTick(()=>{
            //找到联系人的ID
            if(prop.clinicId){
                getClinicInfo(prop.clinicId).then((res: any)=>{
                    data.showStatistic = true;
                    data.id = res.contact.id;
                    data.type = 1;
                    search(1, res.contact.id);
                })
            }
        })
    },
    {
        immediate: true,
        deep: true,
    }
);

watch(
    () => prop.relatedId, async () => {
        if(prop.relatedId){
            await nextTick(()=>{
                data.showStatistic = false;
                data.type = 2;
                data.id = prop.relatedId
                search(2, prop.relatedId);
            })
        }
    },
    {
        immediate: true,
        deep: true,
    }
);

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "订单类型",
        dataIndex: "key",
        key: "key",
        customRender: ({ record }: any) => orderTypeColumns[record.type - 1],
    },
    {
        title: "患者姓名",
        dataIndex: "relatedName",
        key: "relatedName",
    },
    {
        title: "患者手机号",
        dataIndex: "mobile",
        key: "mobile",
    },
    {
        title: "拍摄时间",
        dataIndex: "creationDate",
        key: "creationDate",
        customRender: ({ record }: any) => {
            return record.creationDate ? formatDateTime(record.creationDate) : "";
        },
    },
    {
        title: "拍摄状态",
        dataIndex: "completed",
        key: "completed",
        customRender: ({ record }: any) => {
            return record.completed ? "已完成" : "未完成"
        },
    },
    {
        title: "报告状态",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.reported]
    },
    {
        title: "流程状态",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.status]
    },
    {
        title: "操作",
        dataIndex: "operation",
        key: "operation",
    },
]

const data = reactive({
    dataSource: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    loading: false,
    id: "",
    type: 1,
    showStatistic: true,
    totalRecharge: 0,
    usedRecharge: 0,
    validRecharge: 0,
    //面照
    faceVisible: false,
    faceImagePath:'',
    //口内照
    detectionVisible: false,
    oralDetectionOrderId: ""
})

/**
 *
 * @param type 1：诊所端，2：患者
 * @param id 诊所/患者的ID
 */
const search = async (type:number,id:string) => {
    data.loading = true;
    let option = {
        page: {
            currPage: data.pagination.current,
            pageSize: data.pagination.pageSize,
        },
        type: 6,
        owner: "",
        relatedId: "",
        includeCancel: false
    };
    if(type === 1){
        option.owner = id;
        let recharge: any = await getUsedRechargeFrequencyWithUserId(id);
        data.totalRecharge = recharge.rechargeTotalFrequency;
        data.usedRecharge = recharge.rechargeHasUsedFrequency;
        data.validRecharge = recharge.rechargeValidFrequency;
    }else if(type === 2){
        option.relatedId = id;
    }else{
        message.warning("未获取到相应的类型");
        return;
    }
    mobileOrders(option).then((res: any) =>{
        data.loading = false;
        data.dataSource = [];
        data.pagination.total = 0;
        if (null !== res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        }
    })
}

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search(data.type,data.id);
};

const toDetail = (record: any)=>{
    if(record.type === 2){
        data.faceVisible = true;
        getFaceImage(record.id).then((res: { ossUrl: string; })=> {
            data.faceImagePath = res.ossUrl
        })
    }else{
        data.detectionVisible = true;
        data.oralDetectionOrderId = record.id
    }
}

const handleDetectionOk = (e: MouseEvent) => {
    console.log(e);
    data.detectionVisible = false;
    data.oralDetectionOrderId = ''
};

const handleFaceOk = (e: MouseEvent) => {
    console.log(e);
    data.faceVisible = false;
};

return (_ctx: any,_cache: any) => {
  const _component_BgColorsOutlined = _resolveComponent("BgColorsOutlined")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")!
  const _component_DotChartOutlined = _resolveComponent("DotChartOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (data.showStatistic)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 0,
          style: {"margin-bottom":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      title: "已使用次数",
                      value: data.usedRecharge,
                      class: "demo-class",
                      "value-style": { color: '#3f8600' }
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_BgColorsOutlined)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      title: "可用次数",
                      value: data.validRecharge,
                      class: "demo-class",
                      "value-style": { color: '#3f8600' }
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_CheckOutlined)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      title: "总次数",
                      value: data.totalRecharge,
                      class: "demo-class",
                      "value-style": { color: '#3f8600' }
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_DotChartOutlined)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_table, {
      dataSource: data.dataSource,
      loading: data.loading,
      scroll: { y: 400 },
      size: "small",
      columns: columns,
      bordered: "",
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.completed === true)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (toDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("详情")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    _createVNode(_component_a_modal, {
      visible: data.faceVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((data.faceVisible) = $event)),
      title: "面部照",
      onOk: handleFaceOk,
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          bordered: false,
          style: {"text-align":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'Frontal.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'FrontalSmile.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + 'Profile.JPEG'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.faceImagePath + '45Profile.JPEG'
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: data.detectionVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((data.detectionVisible) = $event)),
      title: "口内照",
      onOk: handleDetectionOk,
      width: "60%"
    }, {
      default: _withCtx(() => [
        (data.detectionVisible)
          ? (_openBlock(), _createBlock(PickImage, {
              key: 0,
              oralDetectionOrderId: data.oralDetectionOrderId,
              disabled: false
            }, null, 8, ["oralDetectionOrderId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})